<h1 matDialogTitle [innerHTML]="data.title"></h1>

<mat-dialog-content [innerHTML]="data.message"> </mat-dialog-content>

<mat-dialog-actions [attr.align]="'center'">
  <button
    *ngIf="data.cancell"
    class="alt"
    mat-button
    [mat-dialog-close]="false"
  >
    {{ data.cancell ? data.cancell : 'Cancelar' }}
  </button>
  <button
    *ngIf="data.confirm"
    class="primary"
    mat-button
    [mat-dialog-close]="true"
  >
    {{ data.confirm ? data.confirm : 'Confirmar' }}
  </button>
</mat-dialog-actions>
